import React from 'react';

class Progress extends React.Component {
    render() {
        return (
            <div className="progress">
                <span style={{ width: `${(this.props.step + 1) / 3 * 100}%` }} />
            </div>
        )
    }
}

export default Progress;